import { render, staticRenderFns } from "./gym-calendar.vue?vue&type=template&id=0986f1a2&scoped=true&"
import script from "./gym-calendar.vue?vue&type=script&lang=js&"
export * from "./gym-calendar.vue?vue&type=script&lang=js&"
import style0 from "./gym-calendar.vue?vue&type=style&index=0&id=0986f1a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0986f1a2",
  null
  
)

export default component.exports